var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"preloader"}},[_c('div',{attrs:{"id":"loader"}},[_c('img',{directives:[{name:"set-alt",rawName:"v-set-alt"}],staticClass:"logo-preloader",attrs:{"src":require("../images/Logo.svg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }